export default __webpack_public_path__ + "static/media/Services-1.34e74997.jpg";